import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import Policy_img from "../../assets/img/contact.jpg";

export default function Policy() {
  const messages = defineMessages({
    breadcrumb: {
      id: "page.policy.breadcrumb",
      description: "page policy breadcrumb",
      defaultMessage: "Política de Privacidad",
    },
    title: {
      id: "page.policy.pageTitle",
      description: "page policy title",
      defaultMessage: "Política de Privacidad",
    },
    responsabilityTitle: {
      id: "page.policy.responsabilityTitle",
      description: "policy responsability title",
      defaultMessage:
        "INFORMACIÓN IDENTIFICATIVA DEL RESPONSABLE DE TRATAMIENTO",
    },
    responsabilityTitleOne: {
      id: "page.policy.responsabilityTitleOne",
      description: "policy responsability title one",
      defaultMessage: "Razón Social: ",
    },
    responsabilityInfoOne: {
      id: "page.policy.responsabilityInfoOne",
      description: "policy responsability info one",
      defaultMessage: "INTEDOCS SOLUCIONES DIGITALES S.L",
    },
    responsabilityTitleTwo: {
      id: "page.policy.responsabilityTitleTwo",
      description: "policy responsability title Two",
      defaultMessage: "CIF: ",
    },
    responsabilityInfoTwo: {
      id: "page.policy.responsabilityInfoTwo",
      description: "policy responsability info Two",
      defaultMessage: "B64554629",
    },
    responsabilityTitleThree: {
      id: "page.policy.responsabilityTitleThree",
      description: "policy responsability title Three",
      defaultMessage: "Dirección: ",
    },
    responsabilityInfoThree: {
      id: "page.policy.responsabilityInfoThree",
      description: "policy responsability info Three",
      defaultMessage: "Manuel Girona 16, Bajos 08034 Barcelona",
    },
    responsabilityTitleFour: {
      id: "page.policy.responsabilityTitleFour",
      description: "policy responsability title Four",
      defaultMessage: "Población: ",
    },
    responsabilityInfoFour: {
      id: "page.policy.responsabilityInfoFour",
      description: "policy responsability info Four",
      defaultMessage: "Barcelona",
    },
    responsabilityTitleFive: {
      id: "page.policy.responsabilityTitleFive",
      description: "policy responsability title Five",
      defaultMessage: "Código Postal: ",
    },
    responsabilityInfoFive: {
      id: "page.policy.dataInfoFive",
      description: "policy responsability info Five",
      defaultMessage: "08034",
    },
    responsabilityTitleSix: {
      id: "page.policy.responsabilityTitleSix",
      description: "policy responsability title Six",
      defaultMessage: "Finalidad: ",
    },
    responsabilityInfoSix: {
      id: "page.policy.responsabilityInfoSix",
      description: "policy responsability info Six",
      defaultMessage:
        "Gestión de sus datos de contacto para solventar dudas o sugerencias. Enviarle, en su caso, notificaciones que puedan ser de su interés.",
    },
    privacyTitle: {
      id: "page.policy.privacyTitle",
      description: "policy privacy title",
      defaultMessage: "INFORMACIÓN GENERAL DE PRIVACIDAD",
    },
    privacyText: {
      id: "page.policy.privacyText",
      description: "policy privacy text",
      defaultMessage:
        "La presente Política de privacidad de INTEDOCS SOLUCIONES DIGITALES S.L. regula la obtención, utilización y otras formas de procesamiento de datos personales facilitados por los Usuarios en la presente web o en cualquiera de los entornos de Internet de la entidad. Mediante la implementación de los formularios incluidos en los diferentes websites, relativos a servicios prestados por INTEDOCS SOLUCIONES DIGITALES S.L, los Usuarios aceptan la inclusión y tratamiento de los datos que proporcionen en un tratamiento de datos de carácter personal, del cual es titular INTEDOCS SOLUCIONES DIGITALES S.L   pudiéndose ejercer los derechos pertinentes según lo expuesto en las siguientes cláusulas. Todos los textos legales se encuentran a disposición de los usuarios y/o interesados en la correspondiente web. Dichos textos podrán ser modificados y/o actualizados según las necesidades y actividades llevadas a cabo por INTEDOCS SOLUCIONES DIGITALES S.L.",
    },
    privacyResponsabilityTitle: {
      id: "page.policy.privacyResponsabilityTitle",
      description: "policy privacy responsability title",
      defaultMessage: "¿Quién es responsable del tratamiento de sus datos?",
    },
    privacyResponsabilityText: {
      id: "page.policy.privacyResponsabilityText",
      description: "policy privacy responsability text",
      defaultMessage:
        "INTEDOCS SOLUCIONES DIGITALES S.L, es la persona jurídica responsable de la recogida y procesamiento de sus datos personales en relación con los servicios que la misma presta.\n\n INTEDOCS SOLUCIONES DIGITALES S.L se compromete a respetar y salvaguardar su privacidad y la seguridad de sus datos. Los datos identificativos del responsable de tratamiento son:",
    },
    privacyResponsabilityDataTitleOne: {
      id: "page.policy.privacyResponsabilityDataTitleOne",
      description: "privacy responsability title one",
      defaultMessage: "Razón Social: ",
    },
    privacyResponsabilityDataInfoOne: {
      id: "page.policy.privacyResponsabilityDataTitleOne",
      description: "privacy responsability info one",
      defaultMessage: "INTEDOCS SOLUCIONES DIGITALES S.L",
    },
    privacyResponsabilityDataTitleTwo: {
      id: "page.policy.privacyResponsabilityDataTitleTwo",
      description: "privacy responsability title Two",
      defaultMessage: "CIF: ",
    },
    privacyResponsabilityDataInfoTwo: {
      id: "page.policy.privacyResponsabilityDataInfoTwo",
      description: "privacy responsability info Two",
      defaultMessage: "B64554629",
    },
    privacyResponsabilityDataTitleThree: {
      id: "page.policy.privacyResponsabilityDataTitleThree",
      description: "privacy responsability title Three",
      defaultMessage: "Dirección: ",
    },
    privacyResponsabilityDataInfoThree: {
      id: "page.policy.privacyResponsabilityDataInfoThree",
      description: "privacy responsability info Three",
      defaultMessage: "Manuel Girona 16, Bajos 08034 Barcelona",
    },
    privacyResponsabilityDataTitleFour: {
      id: "page.policy.privacyResponsabilityDataTitleFour",
      description: "privacy responsability title Four",
      defaultMessage: "Población: ",
    },
    privacyResponsabilityDataInfoFour: {
      id: "page.policy.privacyResponsabilityDataInfoFour",
      description: "privacy responsability info Four",
      defaultMessage: "Barcelona",
    },
    privacyResponsabilityDataTitleFive: {
      id: "page.policy.privacyResponsabilityDataTitleFive",
      description: "privacy responsability title Five",
      defaultMessage: "Código Postal: ",
    },
    privacyResponsabilityDataInfoFive: {
      id: "page.policy.privacyResponsabilityDataInfoFive",
      description: "privacy responsability info Five",
      defaultMessage: "08034",
    },
    privacyRecopilationTitle: {
      id: "page.policy.privacyRecopilationTitle",
      description: "policy privacy Recopilation title",
      defaultMessage: "¿Con qué finalidad/es recopilamos sus datos?",
    },
    privacyRecopilationText: {
      id: "page.policy.privacyRecopilationText",
      description: "policy privacy Recopilation text",
      defaultMessage:
        "De acuerdo con lo dispuesto en la normativa vigente, INTEDOCS SOLUCIONES DIGITALES S.L sólo recoge los datos estrictamente necesarios para ofrecer los servicios derivados de su actividad y demás prestaciones, gestiones y actividades atribuidas por la Ley.En la presente web, sólo se tratan datos de contacto, facilitados por los Usuarios. Los datos que se pueden recabar del usuario serán tratados con las finalidades de: Gestión sus datos de contacto para atender sus dudas o sugerencias, con la base legal del interés legítimo de la entidad y la eventual ejecución de medidas precontractuales. Envío de notificaciones que puedan ser de su interés, con la base legal de su consentimiento expreso. Se informa de que no se realizarán evaluaciones automatizadas, ni se elaborarán perfiles de usuarios. Asimismo, le informamos que la información de las bases de datos podrá ser usada para la identificación de los Usuarios y para la realización de estudios estadísticos de los Usuarios registrados. ",
    },
    privacyKeepTitle: {
      id: "page.policy.privacyKeepTitle",
      description: "policy privacy Keep title",
      defaultMessage:
        "¿Durante cuánto tiempo conservamos sus datos personales?",
    },
    privacyKeepText: {
      id: "page.policy.privacyKeepText",
      description: "policy privacy Keep text",
      defaultMessage:
        "Los datos personales serán conservados mientras el usuario no manifieste lo contrario y por los plazos de conservación legalmente establecidos, salvo que por motivos lógicos y evidentes hayan perdido la utilidad o la finalidad legítima para la que fueron captados.",
    },
    privacyRecipientsTitle: {
      id: "page.policy.privacyRecipientsTitle",
      description: "policy privacy Recipients title",
      defaultMessage: "¿A qué destinatarios se comunicarán sus datos?",
    },
    privacyRecipientsText: {
      id: "page.policy.privacyRecipientsText",
      description: "policy privacy Recipients text",
      defaultMessage:
        "Terceros que nos ayudan a proporcionar servicios de Tecnologías de la Información, como proveedores de plataforma, servicios de alojamiento, mantenimiento y soporte en nuestras bases de datos, así como en nuestro software y aplicaciones que pueden contener datos sobre usted. Terceros para entregarle un producto/muestra, por ejemplo, servicios postales de entrega. Agencias de publicidad, marketing, medios digitales y redes sociales para ayudarnos a ofrecer publicidad, marketing y campañas, para analizar su efectividad y para administrar su contacto y sus preguntas. Terceros que nos ayudan a proporcionar servicios digitales y de comercio electrónico como escucha social, localización, programas de lealtad, administración de identidades, calificaciones y reseñas, CRM, análisis web y motor de búsqueda, herramientas de curación de contenido generado por el usuario. INTEDOCS SOLUCIONES DIGITALES S.L colaborará para que los terceros cumplan con la legislación vigente, si bien la responsabilidad será exigible a los citados terceros. INTEDOCS SOLUCIONES DIGITALES S.L no vende, alquila o cede los datos personales de los usuarios de estas web, a excepción del caso que sea necesario para la propia prestación del servicio. INTEDOCS SOLUCIONES DIGITALES S.L no vende, alquila o cede los e-mails de sus usuarios a otras empresas, a excepción del caso que sea necesario para la propia prestación del servicio. La web posee enlaces, aplicaciones o funcionalidades compartidas con terceros, como son redes sociales o sistemas de comunicación on-line, INTEDOCS SOLUCIONES DIGITALES S.L no se hace responsable de las informaciones que se recojan en dichas aplicaciones, funcionalidades o redes sociales titularidad de terceros al no tener ninguna capacidad de gestión ni control sobre las mismas, siendo por tanto de aplicación los avisos legales y las políticas de privacidad que pudieran constar en los sitios web o similares de los terceros.",
    },
    privacyRightsTitle: {
      id: "page.policy.privacyRightsTitle",
      description: "policy privacy Rights title",
      defaultMessage:
        "¿Cuáles son los derechos de los Usuarios que nos facilitan sus datos?",
    },
    privacyRightsText: {
      id: "page.policy.privacyRightsText",
      description: "policy privacy Rights text",
      defaultMessage:
        "Los Usuarios podrán ejercitar, respecto de los datos recabados en la forma descrita en el punto primero, los derechos reconocidos en el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos y por el que se deroga la Directiva 95/46/CE (Reglamento general de protección de datos), y en particular los derechos de portabilidad, acceso, rectificación, supresión y limitación al tratamiento.\n\n Los derechos referidos en el párrafo precedente, podrán ejercitarse por cada Usuario mediante solicitud escrita y firmada, acompañada de fotocopia de DNI o Pasaporte, dirigida a la siguiente dirección:\n\n INTEDOCS SOLUCIONES DIGITALES S.L\n Manuel Girona 16, Bajos 08034 Barcelona\n\n Asimismo, si hace saber a los Usuarios que pueden retirar el consentimiento para el tratamiento de sus datos en cualquier momento, así como que pueden presentar reclamación ante la Autoridad de Control (Agencia Española de Protección de Datos) de considerarlo oportuno.",
    },
    incidentsTitle: {
      id: "page.policy.incidentsTitle",
      description: "policy incidents title",
      defaultMessage: "COMUNICACIÓN DE INCIDENCIAS E IRREGULARIDADES.",
    },
    incidentsText: {
      id: "page.policy.incidentsText",
      description: "policy incidents text",
      defaultMessage:
        "En el caso de existir alguna conducta o situación que pudiera ser susceptible de generar una incidencia o irregularidad de cualquier clase, se ruega contactar con: INTEDOCS SOLUCIONES DIGITALES S.L Manuel Girona 16, Bajos 08034 Barcelona",
    },
    commitmentTitle: {
      id: "page.policy.commitmentTitle",
      description: "policy commitment title",
      defaultMessage:
        "COMPROMISO DEL USUARIO PARA QUE SUS DATOS ESTÉN INSCRITOS EN UN TRATAMIENTO",
    },
    commitmentText: {
      id: "page.policy.commitmentText",
      description: "policy commitment text",
      defaultMessage:
        "El introducir los datos en alguna o algunas de las hojas de captación de datos implica el aceptar las presentes condiciones de uso y política de privacidad, dando por entendido que ha sido informado de las condiciones de uso y aviso legal de las mismas y que se compromete a su entero cumplimiento durante la navegación y participación en HTTP. En todo caso, el usuario es el responsable de la autenticidad de los datos aportados, que sean exactos, actuales y completos para la finalidad que sean aportados, asumiendo la responsabilidad de los daños y perjuicios, tanto por lucro cesante como por daño emergente, que se pudieran generar por dichas inexactitudes o falsedades. En todo caso, si los datos aportados en los correspondientes formularios fueran titular de un tercero, el usuario se hace único responsable de la correcta captación del consentimiento e información al tercero sobre los aspectos reflejados en el presente aviso legal y políticas de privacidad.",
    },
    usersTitle: {
      id: "page.policy.usersTitle",
      description: "policy users title",
      defaultMessage: "RESPONSABILIDAD DE LOS USUARIOS POR USO Y CONTENIDO",
    },
    usersText: {
      id: "page.policy.usersText",
      description: "policy users text",
      defaultMessage:
        "Tanto el acceso a los websites como el uso que pueda realizarse de la información y contenidos incluidos en los mismos, será de exclusiva responsabilidad de quien lo realice. Por tanto, el uso que pueda hacerse de la información, imágenes, contenidos y/o productos reseñados y accesibles a través del mismo, estará supeditada a la legalidad, sea nacional o internacional, aplicable, así como a los principios de buena fe y uso lícito por parte de los Usuarios, quienes serán enteramente responsables de dicho acceso y correcto uso. Los Usuarios estarán obligados a hacer un uso razonable de los servicios o contenidos, bajo el principio de buena fe y con respeto a la legalidad vigente, a la moral, al orden público, a las buenas costumbres, a los derechos de terceros o del propio INTEDOCS SOLUCIONES DIGITALES S.L, todo ello según las posibilidades y fines para los que están concebidos. INTEDOCS SOLUCIONES DIGITALES S.L no asume responsabilidades, ya sean directas o indirectas, por daño emergente o lucro cesante, derivadas del mal uso de los servicios o contenidos realizado por los Usuarios o terceros.",
    },
    lssiTitle: {
      id: "page.policy.lssiTitle",
      description: "policy lssi title",
      defaultMessage: "INFORMACIÓN LSSI-CE",
    },
    lssiText: {
      id: "page.policy.lssiText",
      description: "policy lssi text",
      defaultMessage:
        "En cumplimiento del deber de información contemplado en el artículo 10 de la vigente Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico, le comunicamos que la dinamizadora y gestora de contenidos de la web donde puede descargar diferentes aplicaciones y/o informaciones es INTEDOCS SOLUCIONES DIGITALES S.L con domicilio en DIRELARGA y con la gestión del dominio de Internet HTTP inscrito en el registro correspondiente, atendiendo a comunicaciones de los usuarios y/o interesados a través del e-mail EMAILENTIDAD.\n\n Cualquier otra actividad comercial, mercantil, administrativa o de contratación de bienes y/o servicios es responsabilidad de la sociedad mencionada anteriormente, propietaria de este dominio.",
    },
    useTitle: {
      id: "page.policy.useTitle",
      description: "policy use title",
      defaultMessage: "INFORMACIÓN SOBRE EL USO DE OTRAS WEBS Y REDES SOCIALES",
    },
    useText: {
      id: "page.policy.useText",
      description: "policy use text",
      defaultMessage:
        "La empresa sólo se hace responsable de los contenidos y de la gestión de las páginas web de la cual sea ella el titular u ostente un derecho de análoga naturaleza. Cualquier otra página web o red social o repositorio de información en Internet, fuera de la presente web, es responsabilidad de sus legítimos titulares.\n\n INTEDOCS SOLUCIONES DIGITALES S.L colabora de forma ordinaria con diferentes aplicaciones y entornos web, y siempre recomienda a todos los usuarios que antes de acceder a dichos entornos web lean atentamente los correspondientes avisos legales y políticas de privacidad, y que sólo accedan a los mismos una vez hayan comprendido y aceptado en su totalidad dicho texto legal.\n\n INTEDOCS SOLUCIONES DIGITALES S.L se compromete a controlar los contenidos que se expongan en dichas redes sociales y expulsará aquellos usuarios que hagan un uso incorrecto en ellas.\n\n INTEDOCS SOLUCIONES DIGITALES S.L recomienda, siguiendo instrucciones del Instituto Nacional de Tecnologías de la Comunicación (INTECO) y de la Agencia Española de Protección de Datos (AEPD), para el uso de redes sociales o navegación en entornos web, la ejecución de las siguientes acciones (en caso de que algún día se disponga al uso):\n\n • Se recomienda a todos los usuarios recurrir al uso de seudónimos o nicks personales con los que operar a través de Internet, permitiéndoles disponer de una auténtica “identidad digital”, que no ponga en entredicho la seguridad de su vida personal y profesional.\n • Se recomienda a los usuarios tener especial cuidado a la hora de publicar contenidos audiovisuales y gráficos en sus perfiles, dado que en este caso pueden estar poniendo en riesgo la privacidad e intimidad de personas de su entorno.\n • Se recomienda revisar y leer, tanto en el momento previo al registro de usuario, como posteriormente, las condiciones generales de uso y la política de privacidad que la plataforma pone a su disposición en sus sitios web.\n • Se recomienda configurar adecuadamente el grado de privacidad del perfil de usuario en la red social, de tal forma que éste no sea completamente público, sino que únicamente tengan acceso a la información publicada en el perfil aquellas personas que hayan sido catalogadas como “amigos” o “contactos directos” previamente por el usuario.\n • Se recomienda aceptar como contacto únicamente a aquellas personas conocidas o con las que mantiene alguna relación previa, no aceptando de forma compulsiva todas las solicitudes de contacto que recibe e investigando siempre que fuera posible y necesario, quién es la persona que solicita su contacto a través de la red social.\n • Se recomienda no publicar en el perfil de usuario información de contacto físico, que permita a cualquier persona conocer dónde vive, dónde trabaja o estudia diariamente o los lugares de ocio que suele frecuentar.\n • A los usuarios de herramientas de microblogging se recomienda tener especial cuidado respecto a la publicación de información relativa a los lugares en que se encuentra en todo momento.\n • Se recomienda utilizar y publicar únicamente contenidos respecto a los que se cuente con los derechos de propiedad intelectual suficientes. En caso contrario, el usuario estará cometiendo un ilícito civil protegible por parte de los tribunales nacionales.\n • Se recomienda a los usuarios emplear diferentes nombres de usuario y contraseñas para entrar en las distintas redes sociales de las que sea miembro.\n • Se recomienda utilizar contraseñas con una extensión mínima de 8 caracteres, alfanuméricos y con uso de mayúsculas y minúsculas.\n • Se recomienda a todos los usuarios disponer en sus equipos de software antivirus instalado y debidamente actualizado.\n • Los menores no deben revelar datos personales excesivos. Nunca se deben suministrar los datos a desconocidos.\n • Se debe leer toda la información concerniente a la página web. En ella se explica quiénes son los titulares de la misma y la finalidad para la que se solicitan los datos.\n • Si el usuario es menor de catorce años, se necesita también el consentimiento de los padres tutores. En estos casos, siempre que se soliciten datos por parte de una red social debe preguntarse a los padres o tutores para ver si ellos aprueban la suscripción o no.\n • No deben comunicarse a terceros los nombres de usuario y contraseña, ni compartirlos entre amigos o compañeros de clase. Estos datos son privados y no deben ser comunicados a terceros y/o desconocidos.\n • Siempre que se tenga cualquier duda respecto a alguna situación que se derive del uso de las redes sociales y herramientas colaboradoras, debe preguntarse a los padres o tutores.\n • Se debe mantener el ordenador en una zona común de la casa.\n • Se deben establecer reglas sobre el uso de Internet en casa.\n • Los padres deben conocer el funcionamiento y las posibilidades de este tipo de plataformas, tanto positivas como negativas.\n • Activar el control parental y las herramientas de control de la plataforma, así como establecer el correo del padre o tutor como correo de contacto secundario.\n • Asegurarse de que los controles de verificación de la edad están implementados.\n • Asegurar la correcta instalación del bloqueador de contenidos.\n • Concienciar e informar a los menores sobre aspectos relativos a la seguridad.\n • Explicar a los menores que nunca han de quedar con personas que hayan conocido en el mundo online y que si lo hacen debe ser siempre en compañía de sus padres o tutores.",
    },
  });

  return (
    <>
      <section className="contact-page half-wrapper responsive-multimedia-off">
        <div className="half-breadcrumbs color">
          <ol
            className="breadcrumbs-list"
            itemScope
            itemType="http://schema.org/BreadcrumbList"
          >
            <li
              className="breadcrumbs-list-element active"
              itemProp="itemListElement"
              itemScope
              itemType="http://schema.org/ListItem"
            ></li>
          </ol>
        </div>
        <div className="wrapper">
          <div className="wrap-contact-page">
            <header className="contact-page-header">
              <div className="wrap-contact-header">
                <h1 className="contact-header-title">
                  <FormattedMessage {...messages.title} />
                </h1>
              </div>
            </header>
            <div className="contact-page-info pre-table">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.responsabilityTitle} />
                </p>
              </div>
            </div>
            <div className="contact-page-details">
              <div className="wrap-contact-details">
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.responsabilityTitleOne}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.responsabilityInfoOne}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.responsabilityTitleTwo}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.responsabilityInfoTwo}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.responsabilityTitleThree}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.responsabilityInfoThree}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.responsabilityTitleFour}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.responsabilityInfoFour}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.responsabilityTitleFive}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.responsabilityInfoFive}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.responsabilityTitleSix}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.responsabilityInfoSix}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.privacyTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.privacyText} />
                </p>
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.privacyResponsabilityTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.privacyResponsabilityText} />
                </p>
              </div>
            </div>
            <div className="contact-page-details">
              <div className="wrap-contact-details">
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataTitleOne}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataInfoOne}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataTitleTwo}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataInfoTwo}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataTitleThree}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataInfoThree}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataTitleFour}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataInfoFour}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="contact-details-element">
                  <div className="wrap-details-element">
                    <div className="details-element-header">
                      <div className="wrap-details-header">
                        <p className="details-header-title">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataTitleFive}
                          />
                        </p>
                      </div>
                    </div>
                    <div className="details-element-content">
                      <div className="wrap-details-content">
                        <p className="details-content-text">
                          <FormattedMessage
                            {...messages.privacyResponsabilityDataInfoFive}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.privacyRecopilationTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.privacyRecopilationText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.privacyKeepTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.privacyKeepText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.privacyRecipientsTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.privacyRecipientsText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-text subtitle">
                  <FormattedMessage {...messages.privacyRightsTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.privacyRightsText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.incidentsTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.incidentsText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.commitmentTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.commitmentText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.usersTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.usersText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.lssiTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.lssiText} />
                </p>
              </div>
            </div>
            <div className="contact-page-info">
              <div className="wrap-contact-info">
                <p className="contact-info-title">
                  <FormattedMessage {...messages.useTitle} />
                </p>
                <p className="contact-info-text">
                  <FormattedMessage {...messages.useText} />
                </p>
              </div>
            </div>
            <div className="half-multimedia">
              <div className="wrap-half-multimedia">
                <div className="half-multimedia-box">
                  <div className="wrap-multimedia-box">
                    <figure
                      className="multimedia-box-element"
                      role="img"
                      data-lazyimg={Policy_img}
                    ></figure>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
